export default {
  // Common
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    filter: 'Filter',
    loading: 'Loading...',
    noData: 'No data',
    confirm: 'Confirm',
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    actions: 'Actions',
    status: 'Status',
    date: 'Date',
    name: 'Name',
    description: 'Description',
    type: 'Type',
    download: 'Download',
    upload: 'Upload',
    copy: 'Copy',
    copied: 'Copied!',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information',
    all: 'All',
    allTypes: 'All types',
    allStatuses: 'All statuses',
    none: 'None',
    active: 'Active',
    inactive: 'Inactive',
    enabled: 'Enabled',
    disabled: 'Disabled',
    refresh: 'Refresh',
    back: 'Back',
    goBack: 'Go Back to Dashboard',
    next: 'Next',
    previous: 'Previous',
    finish: 'Finish',
    submit: 'Submit',
    confirmDeleteItem: 'Are you sure you want to delete this item?',
    validateForReport: 'Validate for Report',
    reset: 'Reset',
    view: 'View',
    details: 'Details',
    more: 'More',
    less: 'Less',
    today: 'Today',
    yesterday: 'Yesterday',
    thisWeek: 'This week',
    thisMonth: 'This month',
    optional: 'optional',
    unknown: 'Unknown',
    notDetected: 'Not Detected',
    notDetectedFeminine: 'Not Detected',
    notAvailable: 'Not available',
    required: 'Required',
    note: 'Note:',
    and: 'and',
    or: 'or',
    sending: 'Sending...',
    copyright: '© 2026 SYLink. All rights reserved.',
    add: 'Add',
    execute: 'Execute',
    launch: 'Launch',
    pause: 'Pause'
  },

  // APT Modules
  apt: {
    dangerousModule: 'Dangerous module - Use with caution',
    addToChain: 'Add to a chain',
    createChain: 'Create an attack chain',
    createChainButton: 'Create chain',
    chainName: 'Chain name',
    selectedModules: 'Selected modules',
    addModulesFromList: 'Add modules from the list on the right',
    availableModules: 'Available modules',
    newChain: 'New chain',
    executeModule: 'Execute {name}',
    loadError: 'Error loading APT data',
    requiredParams: 'Required parameters',
    executions: 'Executions',
    successful: 'successful',
    avgTime: 'Avg. time',
    modulesApt: 'APT Modules',
    chains: 'Chains',
    evidence: 'Evidence',
    mitreMatrix: 'MITRE ATT&amp;CK Matrix',
    category: 'Category',
    criticality: 'Criticality',
    mitreTactic: 'MITRE Tactic',
    allCategories: 'All',
    allCriticalities: 'All',
    allTactics: 'All',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    critical: 'Critical',
    noModulesAvailable: 'No APT campaigns available at the moment',
    noModulesFiltered: 'No modules match the selected filters',
    noChains: 'No attack chains created. Create one to get started.',
    noEvidence: 'No evidence collected. Execute modules to collect evidence.',
    chainStatus: 'Status',
    chainProgress: 'Progress',
    chainModules: 'Modules',
    chainCreatedAt: 'Created',
    executeChain: 'Execute {name}',
    moduleLaunched: 'Module {name} launched',
    moduleLaunchError: 'Error launching module',
    chainCreated: 'Chain created successfully',
    chainCreateError: 'Error creating chain',
    chainLaunched: 'Chain launched',
    chainLaunchError: 'Error launching chain',
    chainPaused: 'Chain paused',
    chainCancelled: 'Chain cancelled',
    dangerWarning: 'This module is marked as dangerous. Use with caution.',
    modulesAvailable: 'modules available',
    target: 'Target',
    duration: 'Duration',
    result: 'Result',
    title: 'Title',
    classification: 'Classification',
    size: 'Size',
    validated: 'Validated',
    searchPlaceholder: 'Search...',
    tool: 'Tool',
    module: 'Module',
    exitCode: 'Exit code',
    status: {
      pending: 'Pending',
      queued: 'Queued',
      running: 'Running',
      paused: 'Paused',
      completed: 'Completed',
      failed: 'Failed',
      cancelled: 'Cancelled',
      draft: 'Draft',
      ready: 'Ready'
    },
    categories: {
      reconnaissance: 'Reconnaissance',
      resource_development: 'Resource Development',
      initial_access: 'Initial Access',
      execution: 'Execution',
      persistence: 'Persistence',
      privilege_escalation: 'Privilege Escalation',
      defense_evasion: 'Defense Evasion',
      credential_access: 'Credential Access',
      discovery: 'Discovery',
      lateral_movement: 'Lateral Movement',
      collection: 'Collection',
      command_and_control: 'Command and Control',
      exfiltration: 'Exfiltration',
      impact: 'Impact'
    },
    criticalities: {
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      critical: 'Critical'
    }
  },

  // Navigation
  nav: {
    dashboard: 'Dashboard',
    scans: 'Scans',
    workspaces: 'Workspaces',
    vulnerabilities: 'Vulnerabilities',
    reports: 'Reports',
    settings: 'Settings',
    account: 'My Account',
    logout: 'Logout',
    help: 'Help',
    admin: 'Administration',
    tools: 'Tools',
    compliance: 'Compliance',
    notifications: 'Notifications',
    credentials: 'Credentials',
    ad: 'Active Directory',
    sessions: 'Sessions',
    agents: 'Agents'
  },

  // Auth
  auth: {
    login: 'Login',
    logout: 'Logout',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    forgotPassword: 'Forgot password?',
    magicLink: 'Magic Link',
    resetPassword: 'Reset password',
    resetPasswordNeedsLink: 'To reset your password, use the link sent by email. You can request a new link from the login page.',
    rememberMe: 'Remember me',
    loginSuccess: 'Login successful',
    loginError: 'Invalid credentials',
    logoutSuccess: 'Logout successful',
    sessionExpired: 'Session expired',
    twoFactor: 'Two-factor authentication',
    enterCode: 'Enter the code',
    verifyCode: 'Verify code',
    invalidCode: 'Invalid code',
    // Register page
    createAccount: 'Create an account',
    fillFormBelowEmail: 'Fill in the form below to create your business account.',
    companyName: 'Company name',
    companyPlaceholder: 'Your company',
    firstName: 'First name',
    firstNamePlaceholder: 'Your first name',
    lastName: 'Last name',
    lastNamePlaceholder: 'Your last name',
    professionalEmail: 'Professional email',
    professionalEmailPlaceholder: 'you@yourcompany.com',
    professionalPhone: 'Professional phone',
    phonePlaceholder: '+1 234 567 8900',
    passwordEmailNote: 'You will set your password after validating your email.',
    acceptTermsPrefix: 'I accept the',
    createMyAccount: 'Create my account',
    registering: 'Creating...',
    alreadyHaveAccount: 'Already have an account?',
    loginButton: 'Log in',
    byRegistering: 'By creating an account, you agree to our terms of use and privacy policy.',
    registrationSuccess: 'Registration successful!',
    registrationEmailSent: 'A confirmation email has been sent to',
    clickLinkToSetPassword: 'Click the link to set your password and activate your account.',
    checkSpam: 'Check your spam folder if you don\'t see the email.',
    backToLogin: 'Back to login',
    // Login page
    welcomeBack: 'Welcome back!',
    enterCredentials: 'Enter your credentials to access your space.',
    loggingIn: 'Logging in...',
    noAccount: 'Don\'t have an account?',
    createAccountLink: 'Create an account',
    // Email verification
    verifying: 'Verifying...',
    verifyingDescription: 'Please wait while we verify your email address.',
    emailVerified: 'Email verified!',
    accountActive: 'Your account is now active.',
    welcome: 'Welcome to SYLink!',
    choosePlan: 'Choose my plan',
    redirectingToPlan: 'Redirecting to pricing in {seconds} seconds...',
    orLoginDirectly: 'Or {loginLink} directly',
    verificationFailed: 'Verification failed',
    needNewVerificationLink: 'Need a new verification link?',
    yourEmail: 'Your email',
    emailSent: 'Email sent!',
    resendLink: 'Resend link',
    invalidLink: 'Invalid link',
    requestNewVerificationLink: 'Request a new verification link',
    sendLink: 'Send link',
    // Password reset / Forgot password modal
    resetPasswordTitle: 'Reset password',
    resetPasswordDesc: 'Enter your email to receive a reset link.',
    sendResetLink: 'Send reset link',
    forgotPasswordModalTitle: 'Forgot password?',
    emailSentTitle: 'Email sent',
    checkYourInbox: 'Check your inbox',
    ifAccountExistsPrefix: 'If an account exists with the address',
    ifAccountExistsSuffix: ', you will receive a link to reset your password.',
    linkExpiresCheckSpam: 'The link will expire in 24 hours. Please check your spam folder.',
    enterEmailForResetLink: 'Enter your email address and we will send you a link to reset your password.',
    emailAddressLabel: 'Email address',
    sendResetLinkFull: 'Send reset link',
    sendingInProgress: 'Sending...',
    connectionError: 'Connection error. Please try again.',
    sending: 'Sending...',
    resetLinkSent: 'Link sent!',
    resetLinkSentDesc: 'Check your mailbox to reset your password.',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm password',
    setNewPassword: 'Set password',
    passwordUpdated: 'Password updated!',
    passwordUpdatedDesc: 'You can now log in with your new password.',
    // Reset password page
    passwordGenerator: 'Password Generator',
    regenerate: 'Regenerate',
    classic: 'Classic',
    quantumResistant: 'Quantum-Resistant',
    quantumSecurityDescription: 'Maximum security against future quantum attacks',
    passwordChanged: 'Password changed!',
    passwordResetSuccess: 'Your password has been successfully reset. You will be redirected to the login page.',
    chooseSecurePassword: 'Choose a secure password for your account',
    orEnterManually: 'or enter manually',
    newPasswordPlaceholder: 'Enter your new password',
    confirmPasswordPlaceholder: 'Confirm your password',
    minChars: '8 characters min',
    uppercase: '1 uppercase',
    lowercase: '1 lowercase',
    number: '1 number',
    specialChar: '1 special character',
    passwordsMatch: 'Passwords match',
    resettingPassword: 'Resetting...',
    charactersCount: '{count} characters',
    // Login page additional
    loginSubtitle: 'Log in to access your security space.',
    emailNotVerified: 'Email not verified',
    emailNotVerifiedMessage: 'Please check your mailbox and click the confirmation link.',
    verificationEmailSent: 'Verification email sent!',
    resendVerificationLink: 'Resend verification email',
    accountBlocked: 'Account blocked',
    personalEmailBlockedMessage: 'This account uses a personal email address that is no longer accepted.',
    securityPolicy: 'Security policy:',
    professionalEmailOnly: 'Only professional email addresses are allowed.',
    personalEmailsNotAccepted: 'Personal emails (Gmail, Hotmail, Yahoo, etc.) are not accepted.',
    createNewAccountMessage: 'To continue, create a new account with your professional email:',
    createAccountWithProfessionalEmail: 'Create an account with professional email',
    needHelp: 'Need help? Contact us',
    emailOrUsername: 'Email',
    emailPlaceholder: 'you@company.com',
    passwordPlaceholder: 'Password',
    createFreeAccount: 'Create a free account'
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    welcome: 'Welcome, {name}',
    overview: 'Overview',
    recentScans: 'Recent scans',
    statistics: 'Statistics',
    quickActions: 'Quick Actions',
    newScan: 'New scan',
    viewAllScans: 'View all scans',
    totalScans: 'Total scans',
    activeScans: 'Active scans',
    completedScans: 'Completed scans',
    failedScans: 'Failed scans',
    vulnerabilitiesFound: 'Vulnerabilities found',
    criticalVulns: 'Critical vulnerabilities',
    highVulns: 'High vulnerabilities',
    mediumVulns: 'Medium vulnerabilities',
    lowVulns: 'Low vulnerabilities',
    systemHealth: 'System health',
    toolsStatus: 'Tools status',
    cpuUsage: 'CPU usage',
    memoryUsage: 'Memory usage',
    diskUsage: 'Disk usage',
    // Service status
    services: {
      backendApi: 'Backend API',
      frontend: 'Frontend',
      postgresql: 'PostgreSQL',
      aiModels: 'AI Models'
    },
    serviceStatus: {
      online: 'Online',
      offline: 'Offline',
      checking: 'Checking',
      degraded: 'Degraded'
    },
    serverPerformance: 'Server Performance',
    realtimeMonitoring: 'Real-time Monitoring',
    infrastructureTotal: 'Total Infrastructure',
    online: 'Online',
    uptime: 'Uptime',
    activeProcesses: 'Active Processes',
    scansToday: 'Scans Today',
    networkLoad: 'Network Load',
    temperature: 'Temperature',
    resources: {
      high: 'High',
      medium: 'Medium',
      normal: 'Normal',
      critical: 'Critical',
      optimal: 'Optimal',
      active: 'Active',
      inUse: 'In Use',
      idle: 'Idle',
      notDetected: 'Not Detected',
      gpuNotAvailable: 'GPU Not Available',
      aiDisabled: 'AI Disabled',
      cores: 'cores',
      multiCore: 'Multi-core',
      systemLoad: 'System Load',
      used: 'used',
      calculating: 'Calculating...',
      total: 'total',
      totalCores: 'Total Cores',
      totalMemory: 'Total RAM',
      computePower: 'Compute Power',
      ramCapacity: 'RAM Capacity',
      aiCapacity: 'AI Capacity',
      availableTotal: 'Available / Total',
      cpuCores: 'CPU Cores',
      ramInfra: 'Infra. RAM',
      gpuVram: 'GPU VRAM',
      aiReady: 'AI Ready',
      temperatureOk: 'OK',
      servers: 'servers',
      onlineCount: 'online',
      offlineCount: 'offline',
      gpuOnline: 'GPU online',
      model: 'model'
    }
  },

  // Equipment
  equipment: {
    title: 'Equipment Management',
    subtitle: 'Detect, categorize, and attack network equipment',
    totalEquipment: 'Total Equipment',
    totalEquipmentDesc: 'Total number of equipment registered in the database. Includes servers, workstations, network equipment, IoT, OT/ICS and other identified devices.',
    equipmentLabel: 'Equipment',
    totalAttacks: 'Total Attacks',
    successfulAttacks: 'Successful Attacks',
    ongoingAttacks: 'Ongoing Attacks',
    typesTab: 'Equipment Types',
    detectedTab: 'Detected Equipment',
    attacksTab: 'Attacks',
    autoDetect: 'Auto-Detect',
    refresh: 'Refresh',
    searchPlaceholder: 'Search…',
    category: 'Category',
    allCategories: 'All'
  },

  // Scans
  scans: {
    title: 'Scans',
    newScan: 'New scan',
    scanHistory: 'Scan history',
    target: 'Target',
    targets: 'Targets',
    scanType: 'Scan type',
    startScan: 'Start scan',
    stopScan: 'Stop scan',
    pauseScan: 'Pause',
    resumeScan: 'Resume',
    deleteScan: 'Delete scan',
    scanDetails: 'Scan details',
    scanResults: 'Scan results',
    progress: 'Progress',
    duration: 'Duration',
    startedAt: 'Started at',
    completedAt: 'Completed at',
    status: {
      waiting: 'Queued',
      pending: 'Pending',
      running: 'Running',
      completed: 'Completed',
      failed: 'Failed',
      cancelled: 'Cancelled',
      paused: 'Paused',
      stopped: 'Stopped'
    },
    filters: {
      all: 'All',
      failed: 'Failed'
    },
    types: {
      quick: 'Quick scan',
      full: 'Full scan',
      stealth: 'Stealth scan',
      aggressive: 'Aggressive scan',
      custom: 'Custom scan',
      ai_scan: 'AI Scan',
      iot_scan: 'IoT Scan',
      ot_scan: 'OT/ICS Scan',
      full_autonomous: 'Full Autonomous',
      full_auto: 'Full Autonomous',
      full_automation: 'Full Autonomous',
      network_discovery: 'Network Discovery',
      vulnerability_scan: 'Vulnerability Scan',
      expert: 'Expert Scan',
      api_pentest: 'API Pentest',
      ad_pentest: 'Active Directory Pentest',
      ad_scan: 'Active Directory Scan',
      wifi_pentest: 'Wi-Fi Pentest',
      social_engineering: 'Social Engineering',
      red_team: 'Red Team',
      phishing: 'Phishing Campaign'
    },
    phases: {
      discovery: 'Discovery',
      portScan: 'Port scan',
      serviceDetection: 'Service detection',
      vulnScan: 'Vulnerability scan',
      exploitation: 'Exploitation',
      reporting: 'Reporting'
    },
    stealthMode: {
      title: 'Stealth Mode',
      description: 'IDS/IPS evasion techniques',
      none: 'None',
      noneDesc: 'Fast scan, easily detectable',
      basic: 'Basic',
      basicDesc: 'Fragmented packets',
      advanced: 'Advanced',
      advancedDesc: 'Slow timing + spoofing',
      paranoid: 'Paranoid',
      paranoidDesc: 'Maximum evasion (very slow)',
      warning: 'Stealth modes use evasion techniques to avoid IDS/IPS detection'
    },
    hosts: 'Hosts',
    ports: 'Ports',
    services: 'Services',
    openPorts: 'Open ports',
    closedPorts: 'Closed ports',
    filteredPorts: 'Filtered ports',
    noResults: 'No results found',
    exportResults: 'Export results',
    configureScan: 'Configure detailed scan parameters',
    steps: {
      targetType: 'Target & Type',
      networkMode: 'Network Mode',
      scanOptions: 'Scan Options',
      advanced: 'Advanced',
      review: 'Review'
    },
    allScans: 'All scans',
    activeScans: 'Active scans',
    withSuccess: 'Successfully',
    vulnerabilities: 'Vulnerabilities',
    discovered: 'Discovered',
    toReview: 'To review',
    // Sort options
    sortByDate: 'Sort by date',
    sortByStatus: 'Sort by status',
    sortByVulns: 'Sort by vuln.',
    // Stat card tooltips
    tooltips: {
      totalScans: 'Total Scans',
      totalScansDesc: 'Total number of scans launched on the platform. Includes all scans: running, completed, and failed.',
      runningScans: 'Running Scans',
      runningScansDesc: 'Scans currently executing. They analyze targets to detect open ports, services, and vulnerabilities.',
      completedScans: 'Completed Scans',
      completedScansDesc: 'Scans that completed successfully. Results are available for consultation and export in reports.',
      vulnerabilities: 'Detected Vulnerabilities',
      vulnerabilitiesDesc: 'Total security flaws identified. Badges indicate the number of critical and high vulnerabilities requiring immediate attention.',
      hostsDiscovered: 'Discovered Hosts',
      hostsDiscoveredDesc: 'Number of machines (servers, workstations, network equipment) detected during scans. Each host may have multiple exposed ports and services.',
      failedScans: 'Failed Scans',
      failedScansDesc: 'Failed scans (unreachable target, timeout, network issue). Check details to understand the cause and retry if necessary.'
    },
    notFound: 'Scan not found',
    notFoundDesc: 'The requested scan does not exist or has been deleted',
    backToScans: 'Back to scans',
    scanFailed: 'Scan failed',
    genericError: 'An error occurred during scan execution. This may be due to network connectivity issues, unreachable targets, or insufficient resources.',
    technicalDetails: 'Technical details',
    retryScan: 'Retry this scan',
    // Console labels
    consoleLive: 'Live Console',
    consoleCompleted: 'Console (Completed)',
    consoleFailed: 'Console (Failed)',
    consoleTitle: 'Console',
    scanCompletedMessage: '✓ Completed!',
    scanFailedMessage: '✗ Scan failed',
    // Progress steps
    stepCompleted: 'Completed',
    stepWaiting: 'Waiting',
    stepInProgress: 'Scanning',
    // Timestamp labels
    timestampStarted: 'Started',
    timestampCompleted: 'Completed',
    // Cleanup mode
    cleanup: 'Cleanup',
    cleanupTitle: 'Post-pentest cleanup',
    cleanupDescription: 'This action will remove all traces left by the pentest, including:',
    cleanupSessions: 'Active exploitation sessions',
    cleanupPersistence: 'Installed persistence mechanisms',
    cleanupFiles: 'Temporary files and evidence',
    cleanupLogs: 'APT execution logs',
    cleanupPreview: 'Cleanup preview',
    sessionsCount: 'Sessions',
    withPersistence: 'With persistence',
    aptExecutions: 'APT executions',
    evidenceFiles: 'Evidence files',
    evidenceSize: 'Evidence size',
    cleanNow: 'Clean now',
    archiveAndClean: 'Archive and clean',
    cleaning: 'Cleaning...',
    cleanupSuccess: 'Cleanup completed successfully',
    cleanupPartial: 'Partial cleanup (some errors)',
    cleanupFailed: 'Cleanup failed',
    sessionsClosed: 'Sessions closed',
    persistenceRemoved: 'Persistence removed',
    filesCleaned: 'Files cleaned',
    aptLogsCleaned: 'APT logs cleaned',
    evidenceArchived: 'Evidence archived',
    cleanupWarning: '⚠️ This action is irreversible. Make sure you have saved important data.',
    // AI Quota
    aiQuotaExceeded: 'AI Scan Quota Reached',
    aiScansUsed: 'AI Scans used',
    upgradeOptions: 'Options to continue',
    callSylink: 'Call SYLink customer service:',
    upgradePlan: 'Upgrade to a paid plan for unlimited AI scans',
    viewPlans: 'View plans',
    // Scan types for NewScan wizard
    networkDiscovery: 'Network Discovery',
    networkDiscoveryDesc: 'Fast host and port discovery',
    vulnerabilityScan: 'Vulnerability Scan',
    vulnerabilityScanDesc: 'In-depth vulnerability analysis',
    fullAutonomous: 'Full Autonomous',
    fullAutonomousDesc: 'Complete security assessment',
    searchPlaceholder: 'Search by Target or Type...',
    // Placeholders
    placeholders: {
      target: '192.168.1.0/24 or example.com',
      targetExamples: 'Examples: 192.168.1.1, 192.168.1.0/24, example.com, 10.0.0.0/8',
      customPorts: 'e.g.: 80,443,8080-8090',
      excludeHosts: 'e.g.: 192.168.1.1,192.168.1.5'
    },
    // Table column headers
    table: {
      name: 'Name',
      score: 'Score',
      target: 'Target',
      client: 'Client',
      type: 'Type',
      status: 'Status',
      vulnerabilities: 'Vuln.',
      date: 'Date',
      actions: 'Actions'
    }
  },

  // Workspaces
  workspaces: {
    title: 'Client Workspaces',
    newWorkspace: 'New workspace',
    editWorkspace: 'Edit workspace',
    deleteWorkspace: 'Delete workspace',
    workspaceDetails: 'Workspace details',
    clientName: 'Client name',
    clientInfo: 'Client information',
    members: 'Members',
    addMember: 'Add member',
    removeMember: 'Remove member',
    scansCount: 'Scans count',
    lastActivity: 'Last activity',
    created: 'Created on',
    shareWorkspace: 'Share workspace',
    archiveWorkspace: 'Archive workspace',
    noWorkspaces: 'No client workspaces',
    // Form labels
    siret: 'SIRET',
    siretPlaceholder: 'e.g. 123 456 789 00001',
    siren: 'SIREN',
    sirenPlaceholder: 'e.g. 123 456 789',
    // Additional workspace keys
    scans: 'Scans',
    hosts: 'Hosts',
    vulnerabilities: 'Vulnerabilities',
    attackPaths: 'Attack paths',
    successfulScans: 'Successful scans',
    company: 'Company',
    legalForm: 'Legal form',
    address: 'Address',
    city: 'City',
    website: 'Website',
    shareDescription: 'Share this workspace with your clients or collaborators',
    manageShares: 'Manage shares',
    mainContact: 'Main contact',
    contact: 'Contact',
    signed: 'Signed',
    pending: 'Pending',
    draft: 'Draft',
    contractSigned: 'Contract signed',
    contractNotSigned: 'Contract not signed',
    pendingContract: 'Pending contract',
    noContract: 'No contract',
    noScans: 'No scans associated',
    noScansHint: 'Associate an existing scan or launch a new one from the Scans page',
    noHosts: 'No hosts',
    noVulnerabilities: 'No vulnerabilities',
    noAttackPaths: 'No attack paths',
    // Network stats
    vulnerable: 'Vulnerable',
    subnets: 'Subnets',
    services: 'Services',
    noAttackTree: 'No attack tree',
    noVPN: 'No VPN configured',
    // AI Analysis
    aiAnalysis: 'AI Analysis',
    generateSummary: 'Generate summary',
    launchAiAnalysis: 'Launch AI analysis',
    analysisInProgress: 'Analysis in progress...',
    completeAnalysis: 'Complete analysis & Solutions',
    aggregatedData: 'Aggregated data',
    riskAnalysis: 'Risk analysis',
    clickToGenerateSummary: 'Click "Generate summary" to get an AI analysis',
    noAnalysisAvailable: 'No analysis available',
    clickToLaunchAnalysis: 'Click the button above to launch AI analysis',
    launchScanToDiscoverNetwork: 'Run a scan to discover the network',
    critical: 'Critical',
    high: 'High',
    download: 'Download',
    deleteStoredCredentials: 'Delete stored credentials',
    useStoredCredentials: 'use stored credentials',
    enterVpnUsername: 'Enter your VPN username',
    enterVpnPassword: 'Enter your VPN password',
    // VPN Modal
    actionPlan: 'Action Plan & Solutions',
    noDocuments: 'No documents generated for this workspace',
    reportsWillAppear: 'Reports will appear here after generation',
    vpnCredentials: 'VPN Credentials',
    requiresAuthentication: 'requires authentication',
    storedCredentials: 'Stored credentials',
    clickToUseCredentials: 'Click "Connect" to use these credentials',
    connect: 'Connect',
    cancel: 'Cancel',
    username: 'Username',
    password: 'Password',
    saveCredentials: 'Save these credentials',
    saveCredentialsSecurely: 'Save credentials securely',
    credentialsStorageInfo: 'Credentials will be encrypted (AES-256) and stored in the database. They will be automatically used for future VPN connections.',
    saving: 'Saving...',
    connecting: 'Connecting...',
    server: 'Server',
    protocol: 'Protocol',
    noVulnsToFix: 'No vulnerabilities to fix',
    connectionInProgress: 'Connection in progress...',
    connectionFailed: 'Connection failed',
    generateActionPlan: 'Generate action plan',
    clickToGenerateActionPlan: 'Click "Generate action plan" to get recommendations',
    vpnConnected: 'VPN connected! IP:',
    // Workspace Switcher
    select: 'Select workspace',
    selectTitle: 'Select Workspace',
    selectDescription: 'Choose a workspace to continue',
    searchPlaceholder: 'Search workspaces...',
    noWorkspacesYet: 'No workspaces yet',
    noResults: 'No matching workspaces',
    createFirst: 'Create your first workspace',
    createNew: 'Create New',
    manageAll: 'Manage Workspaces',
    continue: 'Continue',
    switchError: 'Failed to switch workspace',
    switchSuccess: 'Workspace switched successfully',
    // Schedules
    scanSchedules: 'Scan Schedules',
    addSchedule: 'Add Schedule',
    noSchedules: 'No schedules configured',
    noSchedulesHint: 'Click "Add Schedule" to automate your scans',
    // Days of week (Monday-first to match backend convention)
    dayMon: 'Mon',
    dayTue: 'Tue',
    dayWed: 'Wed',
    dayThu: 'Thu',
    dayFri: 'Fri',
    daySat: 'Sat',
    daySun: 'Sun',
    nextRun: 'Next'
  },

  // Workspace (alias for workspace switcher)
  workspace: {
    select: 'Select Workspace',
    selectTitle: 'Select Workspace',
    selectDescription: 'Choose a workspace to continue',
    searchPlaceholder: 'Search workspaces...',
    noWorkspaces: 'No workspaces available',
    noWorkspacesYet: 'No workspaces yet',
    noResults: 'No matching workspaces',
    createFirst: 'Create your first workspace',
    createNew: 'Create New',
    manageAll: 'Manage Workspaces',
    continue: 'Continue',
    switchError: 'Failed to switch workspace',
    switchSuccess: 'Workspace switched successfully',
    scan: 'scan',
    scans: 'scans',
    createRequired: 'Workspace Required',
    createRequiredDescription: 'You need a workspace to access this section. Create your first workspace to continue.',
    selectRequired: 'Select a Workspace',
    selectRequiredDescription: 'Please select a workspace to access this section. You have',
    workspacesAvailable: 'workspace(s) available.',
    selectWorkspace: 'Select Workspace'
  },

  // Vulnerabilities
  vulnerabilities: {
    title: 'Vulnerabilities',
    subtitle: 'Analysis and management of detected vulnerabilities',
    aiAssistant: 'AI Assistant',
    aiAssistantDesc: 'Analyze and exploit vulnerabilities autonomously',
    vulnerability: 'Vulnerability',
    severity: 'Severity',
    severities: {
      critical: 'Critical',
      high: 'High',
      medium: 'Medium',
      low: 'Low',
      info: 'Informational'
    },
    cve: 'CVE',
    cvss: 'CVSS Score',
    affected: 'Affected',
    solution: 'Solution',
    references: 'References',
    evidence: 'Evidence',
    exploitable: 'Exploitable',
    verified: 'Verified',
    falsePositive: 'False positive',
    validation: {
      confirmed: 'Confirmed exploitable',
      theoretical: 'Theoretical',
      not_exploitable: 'Not exploitable',
      unvalidated: 'Unvalidated',
      poc_title: 'Proof of Concept',
      narrative: 'Exploitation narrative',
      exploit_path: 'Exploit path',
      prerequisites: 'Prerequisites',
    },
    markAsFixed: 'Mark as fixed',
    noVulnerabilities: 'No vulnerabilities found',
    export: 'Export vulnerabilities',
    distributionBySeverity: 'Distribution by Severity',
    priority: {
      auto: 'Automatic',
    },
    // Action Panel
    actionPanel: {
      title: 'Actions on vulnerability',
    },
    // Attack Chain
    attackChain: {
      title: 'Attack Chain Ranking',
      subtitle: 'Multi-vulnerability risk analysis for target penetration',
      riskScore: 'Risk score',
      vulnCount: 'vulnerabilities',
      attackPath: 'Attack path to objective',
      // Chart
      chartTitle: 'Vulnerability Distribution',
      chartSubtitle: 'Statistical analysis of detected CVEs',
      bySeverity: 'Distribution by Severity',
      keyMetrics: 'Key Metrics',
      totalVulns: 'Total CVE',
      avgCvss: 'Average CVSS',
      criticalHigh: 'Critical + High',
      affectedHosts: 'Affected Hosts',
      topCves: 'Top CVE by CVSS',
      // Stages
      stages: {
        initialAccess: 'Initial Access',
        privEscalation: 'Privilege Escalation',
        persistence: 'Persistence',
        objective: 'Objective'
      },
      exploitVia: 'Exploitation via',
      escalationVia: 'Escalation via',
      maintenanceVia: 'Persistence via',
      fullCompromise: 'Full system compromise',
      adminAccess: 'Admin access possible',
      initialSystemAccess: 'Initial system access',
      // Risk Factors
      riskFactors: 'Risk factors',
      factors: {
        multiVuln: 'Multi-vulnerabilities',
        multiVuln5: '{count} chainable vulns',
        multiVuln3: '{count} vulns on this host',
        criticalHighCombo: 'Critical + High combo',
        rce: 'Potential RCE',
        authBypass: 'Auth bypass possible',
        privEsc: 'Privilege escalation',
        exposed: 'Exposed services',
        highCvss: 'Average CVSS {score}'
      },
      // Ratings
      ratingCritical: 'CRITICAL',
      ratingHigh: 'HIGH',
      ratingMedium: 'MEDIUM',
      ratingLow: 'LOW',
      ratingSafe: 'SAFE',
      // Details
      criticalPath: 'CRITICAL PATH',
      vulnsInChain: 'Vulnerabilities in this chain',
      noChains: 'No attack chains detected',
      noVulnsDesc: 'No vulnerabilities found to analyze attack paths.',
      viewDetails: 'View details',
      multiVulnWarning: 'Increased risk: multiple chainable vulnerabilities',
      // Recommendations
      recommendation: 'Exploitation recommendation',
      recoCritical: 'This target presents a critical risk. The combination of {count} vulnerabilities allows full system compromise. Maximum priority for remediation.',
      recoHigh: 'High risk of compromise. Combined vulnerabilities offer a viable attack path. Corrective action recommended as soon as possible.',
      recoMedium: 'Moderate risk. Some vulnerabilities could be chained for exploitation. Monitor and fix according to priority.',
      recoLow: 'Low risk. Present vulnerabilities have limited impact and are difficult to chain exploit.',
      // Stats
      criticalPaths: 'Critical Paths',
      highRisk: 'High Risk',
      multiVuln: 'Multi-Vulns (3+)',
      hostsAnalyzed: 'Hosts Analyzed',
      avgScore: 'Average Score',
      // Info
      infoText: 'This ranking identifies the most vulnerable hosts by analyzing exploitable vulnerability combinations to achieve penetration objectives.',
      // Legend
      legendCritical: 'Critical (80-100)',
      legendHigh: 'High (60-79)',
      legendMedium: 'Medium (40-59)',
      legendLow: 'Low (20-39)',
      legendSafe: 'Safe (0-19)'
    }
  },

  // Reports
  reports: {
    title: 'Reports',
    newReport: 'New report',
    generateReport: 'Generate report',
    downloadReport: 'Download report',
    reportType: 'Report type',
    settings: 'Settings',
    branding: 'Branding',
    types: {
      executive: 'Executive report',
      technical: 'Technical report',
      compliance: 'Compliance report',
      full: 'Full report',
      vulnerability_list: 'Vulnerability report',
      redteam: 'Red Team report',
      retest: 'Retest report',
      multi_campaign: 'Multi-campaign report',
      active_directory: 'Active Directory report',
      data_leak: 'Data leak report',
      attack_surface: 'Attack surface report'
    },
    format: 'Format',
    formats: {
      pdf: 'PDF',
      html: 'HTML',
      json: 'JSON',
      csv: 'CSV',
      docx: 'Word (DOCX)',
      xml: 'XML',
      jira: 'Jira',
      servicenow: 'ServiceNow',
      glpi: 'GLPI',
      pptx: 'PowerPoint (PPTX)',
      txt: 'Text (TXT)',
      xlsx: 'Excel (XLSX)'
    },
    includeEvidence: 'Include evidence',
    includeRemediation: 'Include remediation',
    generatedAt: 'Generated at',
    generatedBy: 'Generated by',
    noReports: 'No reports',
    // AI Generated Reports
    aiGenerated: 'AI Reports',
    generated: {
      title: 'AI Generated Reports',
      subtitle: 'Professional LLM-powered reports',
      create: 'Create report',
      createNew: 'New AI report',
      selectType: 'Report type',
      selectScan: 'Select a scan',
      selectWorkspace: 'Select a workspace',
      selectFormat: 'Output format',
      generating: 'Generating...',
      regenerate: 'Regenerate',
      regenerateSection: 'Regenerate this section',
      export: 'Export',
      download: 'Download',
      delete: 'Delete',
      confirmDelete: 'Are you sure you want to delete this report?',
      status: {
        pending: 'Pending',
        generating: 'Generating',
        completed: 'Completed',
        failed: 'Failed',
        cancelled: 'Cancelled'
      },
      sections: {
        executive_summary: 'Executive summary',
        key_findings: 'Key findings',
        recommendations: 'Recommendations',
        technical_details: 'Technical details',
        vulnerability_analysis: 'Vulnerability analysis',
        risk_assessment: 'Risk assessment',
        remediation_plan: 'Remediation plan',
        attack_narrative: 'Attack narrative',
        mitre_mapping: 'MITRE ATT&CK mapping',
        timeline: 'Timeline',
        appendix: 'Appendix'
      },
      quality: {
        score: 'Quality score',
        excellent: 'Excellent',
        good: 'Good',
        average: 'Average',
        poor: 'Poor'
      },
      noReports: 'No generated reports',
      noReportsDesc: 'Create your first AI report to get started',
      totalReports: 'Total reports',
      completedReports: 'Completed reports',
      averageQuality: 'Average quality',
      lastGenerated: 'Last generated'
    },
    // Export modal
    export: {
      title: 'Export',
      processing: 'Exporting...',
      generating: 'Generating file',
      takingLong: 'This operation is taking longer than expected.',
      canWaitOrEmail: 'You can wait, or close this window and we will send you a link by email.',
      sendByEmail: 'Send by email',
      continueWaiting: 'You can also continue waiting, the download will start automatically.',
      emailSent: 'Email sent!',
      emailSentDesc: 'You will receive the download link by email shortly.',
      wordLocked: 'Available for Enterprise plans and above'
    },
    // Report configuration placeholders
    placeholders: {
      footerText: 'E.g.: Confidential document - Do not distribute',
      logoUrl: 'https://company.com/logo.png',
      contactEmail: 'contact@example.com',
      sectionTitle: 'Section title...',
      sectionDescription: 'Description (optional)...',
      contentTemplate: 'Enter content template (Markdown supported)...\n\nAvailable variables:\n{{scan.target}} - Scan target\n{{scan.date}} - Scan date\n{{vulnerabilities.count}} - Vulnerabilities count\n{{vulnerabilities.critical}} - Critical vulnerabilities'
    },
    // Report configuration labels
    config: {
      title: 'Configuration',
      subtitle: 'Configure available report types and customize their content',
      settingsTitle: 'Report settings',
      brandingTitle: 'Report branding',
      defaultLanguage: 'Default language',
      confidentialityLevel: 'Confidentiality level',
      includeOptions: 'Include options',
      includeLogo: 'Include logo',
      includeTableOfContents: 'Include table of contents',
      includeAppendices: 'Include appendices',
      includeMethodology: 'Include methodology',
      footerTextLabel: 'Footer text',
      logoUrlLabel: 'Logo URL',
      primaryColor: 'Primary color',
      secondaryColor: 'Secondary color',
      companyInfo: 'Company information (for reports)',
      companyName: 'Company name',
      address: 'Address',
      contactEmail: 'Contact email',
      phone: 'Phone',
      website: 'Website',
      sectionsTitle: 'Report sections',
      addSection: 'Add section',
      noTypeSelected: 'No type selected',
      noTypeSelectedHint: 'Click on a report type in the list to view and customize its sections',
      sectionRequired: 'Required section',
      sectionActive: 'Active',
      requiredBadge: 'Required',
      contentTemplateLabel: 'Content template (Markdown supported)',
      clickToAddTemplate: 'Click to add a content template...',
      markdownHint: 'Use Markdown for formatting. Variables: {{variable}}',
      noReportTypes: 'No report types available'
    }
  },

  // Account
  account: {
    title: 'My Account',
    profile: 'Profile',
    security: 'Security',
    subscription: 'Subscription',
    billing: 'Billing',
    credits: 'Credits',
    notifications: 'Notifications',
    integrations: 'Integrations',
    referral: 'Referral',
    activity: 'Activity',
    contracts: 'Contracts',

    // Profile section
    profileSection: {
      title: 'Profile Information',
      avatar: 'Profile picture',
      changeAvatar: 'Change picture',
      removeAvatar: 'Remove picture',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone',
      company: 'Company',
      position: 'Position',
      timezone: 'Timezone',
      language: 'Portal language',
      languageDescription: 'Choose the display language for the interface',
      updateSuccess: 'Profile updated successfully',
      updateError: 'Error updating profile',
      // Language names in English
      languages: {
        fr: 'French',
        en: 'English',
        es: 'Spanish',
        de: 'German',
        it: 'Italian',
        pt: 'Portuguese'
      }
    },

    // Security section
    securitySection: {
      title: 'Account Security',
      changePassword: 'Change password',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmPassword: 'Confirm password',
      passwordRequirements: 'Password must be at least 8 characters',
      twoFactorAuth: 'Two-factor authentication',
      enable2FA: 'Enable 2FA',
      disable2FA: 'Disable 2FA',
      twoFactorEnabled: '2FA enabled',
      twoFactorDisabled: '2FA disabled',
      activeSessions: 'Active sessions',
      revokeSession: 'Revoke session',
      revokeAllSessions: 'Revoke all sessions',
      loginHistory: 'Login history',
      lastLogin: 'Last login',
      apiKeys: 'API Keys',
      generateApiKey: 'Generate API key',
      deleteApiKey: 'Delete API key'
    },

    // Subscription section
    subscriptionSection: {
      title: 'Subscription',
      currentPlan: 'Current plan',
      planDetails: 'Plan details',
      features: 'Included features',
      usage: 'Usage',
      limits: 'Limits',
      renewalDate: 'Renewal date',
      cancelSubscription: 'Cancel subscription',
      upgradePlan: 'Upgrade plan',
      downgradePlan: 'Downgrade plan',
      plans: {
        free: 'Free',
        pro: 'Pro',
        enterprise: 'Enterprise',
        dedicated: 'Dedicated'
      }
    },

    // Credits section
    creditsSection: {
      title: 'Credits Management',
      balance: 'Balance',
      totalCredits: 'Total credits',
      monthlyCredits: 'Monthly credits',
      packCredits: 'Pack credits',
      usedThisMonth: 'Used this month',
      remaining: 'Remaining',
      buyCredits: 'Buy credits',
      creditHistory: 'Credit history',
      transaction: 'Transaction',
      amount: 'Amount',
      creditCosts: 'Operation costs',
      scanCost: 'Scan cost',
      reportCost: 'Report cost',
      statusPremium: 'PREMIUM',
      statusExhausted: 'EXHAUSTED',
      statusCritical: 'CRITICAL',
      statusLow: 'LOW',
      unlimited: 'Unlimited'
    },

    // Notifications section
    notificationsSection: {
      title: 'Notification Preferences',
      emailNotifications: 'Email notifications',
      pushNotifications: 'Push notifications',
      scanCompleted: 'Scan completed',
      scanFailed: 'Scan failed',
      newVulnerability: 'New critical vulnerability',
      reportReady: 'Report ready',
      securityAlerts: 'Security alerts',
      weeklyDigest: 'Weekly digest',
      marketingEmails: 'Marketing emails'
    },

    // Integrations section
    integrationsSection: {
      title: 'Integrations',
      connected: 'Connected',
      notConnected: 'Not connected',
      configure: 'Configure',
      disconnect: 'Disconnect',
      testConnection: 'Test connection',
      connectionSuccess: 'Connection successful',
      connectionFailed: 'Connection failed',
      availableIntegrations: 'Available integrations',
      myIntegrations: 'My integrations'
    },

    // Referral section
    referralSection: {
      title: 'Referral Program',
      referralLink: 'Referral link',
      copyLink: 'Copy link',
      shareLink: 'Share link',
      inviteFriends: 'Invite friends',
      referralStats: 'Referral statistics',
      totalReferrals: 'Total referrals',
      pendingReferrals: 'Pending referrals',
      completedReferrals: 'Completed referrals',
      earnedCredits: 'Earned credits',
      inviteByEmail: 'Invite by email',
      contacts: 'Invited contacts',
      rewards: 'Rewards',
      leaderboard: 'Leaderboard'
    }
  },

  // Settings
  settings: {
    title: 'Settings',
    general: 'General',
    tools: 'Tools',
    network: 'Network',
    advanced: 'Advanced',

    // General settings
    generalSection: {
      title: 'General Settings',
      defaultScanType: 'Default scan type',
      defaultReportFormat: 'Default report format',
      autoSaveReports: 'Auto-save reports',
      enableNotifications: 'Enable notifications',
      darkMode: 'Dark mode',
      compactView: 'Compact view'
    },

    // Tools settings
    toolsSection: {
      title: 'Tools Configuration',
      enabledTools: 'Enabled tools',
      toolSettings: 'Tool settings',
      timeout: 'Timeout',
      threads: 'Thread count',
      verbosity: 'Verbosity level'
    },

    // Network settings
    networkSection: {
      title: 'Network Configuration',
      proxySettings: 'Proxy settings',
      vpnSettings: 'VPN settings',
      dnsSettings: 'DNS settings',
      useProxy: 'Use proxy',
      proxyHost: 'Proxy host',
      proxyPort: 'Proxy port'
    },

    // Server status
    uptime: 'Uptime'
  },

  // Admin
  admin: {
    title: 'Administration',
    users: 'Users',
    companies: 'Companies',
    system: 'System',
    logs: 'Logs',
    maintenance: 'Maintenance',

    // Users management
    usersSection: {
      title: 'User Management',
      addUser: 'Add user',
      editUser: 'Edit user',
      deleteUser: 'Delete user',
      activateUser: 'Activate user',
      deactivateUser: 'Deactivate user',
      resetPassword: 'Reset password',
      role: 'Role',
      roles: {
        admin: 'Administrator',
        user: 'User',
        viewer: 'Viewer'
      },
      lastLogin: 'Last login',
      createdAt: 'Created at',
      noUsers: 'No users'
    },

    // System
    systemSection: {
      title: 'System',
      systemInfo: 'System information',
      version: 'Version',
      uptime: 'Uptime',
      restart: 'Restart',
      backup: 'Backup',
      restore: 'Restore',
      update: 'Update'
    }
  },

  // Errors
  errors: {
    generic: 'An error occurred',
    notFound: 'Page not found',
    unauthorized: 'Unauthorized access',
    forbidden: 'Access forbidden',
    serverError: 'Server error',
    networkError: 'Network error',
    timeout: 'Request timeout',
    validation: 'Validation error',
    invalidEmail: 'Invalid email',
    invalidPassword: 'Invalid password',
    passwordMismatch: 'Passwords do not match',
    requiredField: 'This field is required',
    minLength: 'Minimum {min} characters required',
    maxLength: 'Maximum {max} characters allowed',
    fillAllFields: 'Please fill in all required fields',
    verificationFailed: 'Email verification failed. The link may be expired or invalid.',
    invalidVerificationLink: 'This verification link is invalid or has expired. Please request a new link.',
    rateLimitExceeded: 'Too many attempts. Please try again in a few minutes.',
    emailAlreadyUsed: 'This email is already in use',
    companyAlreadyRegistered: 'This company is already registered',
    registrationError: 'Error during registration',
    genericError: 'An unexpected error occurred',
    disposableEmailNotAllowed: 'Disposable emails are not allowed',
    personalEmailNotAllowed: 'The email {domain} is not allowed. Use a professional email.',
    invalidResetLink: 'This reset link is invalid or has expired. Please request a new link.',
    resetLinkExpired: 'This reset link has expired. Please request a new link.',
    resetPasswordFailed: 'Password reset failed. Please try again.',
    passwordCriteriaNotMet: 'Password does not meet all required criteria.',
    // Error page
    401: {
      title: 'Unauthorized',
      subtitle: 'Oops! You need to log in',
      description: 'Your session has expired or you are not authenticated. Please log in to access this page.',
      redirectText: 'Redirecting to login'
    },
    403: {
      title: 'Access Denied',
      subtitle: 'Oops! Access forbidden',
      description: 'You do not have the necessary permissions to access this resource.',
      redirectText: 'Redirecting to dashboard'
    },
    404: {
      title: 'Page Not Found',
      subtitle: 'Oops! Page not found',
      description: 'The page you are looking for does not exist or has been moved.',
      redirectText: 'Redirecting to dashboard'
    },
    500: {
      title: 'Server Error',
      subtitle: 'Oops! An error occurred',
      description: 'The server encountered an error. Please try again in a few moments.',
      redirectText: 'Redirecting to dashboard'
    },
    backToDashboard: 'Back to Dashboard',
    retry: 'Retry',
    supportContact: 'If the problem persists, contact technical support.',
    redirectingIn: 'in',
    seconds: 'seconds'
  },

  // Success messages
  success: {
    saved: 'Saved successfully',
    deleted: 'Deleted successfully',
    updated: 'Updated successfully',
    created: 'Created successfully',
    copied: 'Copied to clipboard',
    sent: 'Sent successfully',
    uploaded: 'Uploaded successfully'
  },

  // Time
  time: {
    now: 'Now',
    seconds: 'seconds',
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
    weeks: 'weeks',
    months: 'months',
    years: 'years',
    ago: 'ago',
    in: 'in'
  },

  // Credentials
  credentials: {
    title: 'Credentials',
    username: 'Username',
    password: 'Password',
    hash: 'Hash',
    domain: 'Domain',
    source: 'Source',
    foundAt: 'Found at',
    noCredentials: 'No credentials found',
    export: 'Export credentials'
  },

  // Sessions
  sessions: {
    title: 'Sessions',
    pageTitle: 'Exploitation Sessions',
    pageDescription: 'Management of exploitation sessions and compromised access',
    sessionDetails: 'Session details',
    activeSession: 'Active session',
    closedSession: 'Closed session',
    sessionType: 'Session type',
    target: 'Target',
    startedAt: 'Started at',
    endedAt: 'Ended at',
    duration: 'Duration',
    commands: 'Commands',
    noSessions: 'No sessions',
    closeSession: 'Close session',
    interactiveShell: 'Interactive Shell',
    quickActions: 'Quick Actions',
    quickCommands: 'Quick Commands',
    defaultSessionType: 'Shell',
    sessionLabel: 'Session',
    manualExploit: 'Manual',
    platform: 'Platform',
    platformUnknown: 'Unknown',
    exploitUsed: 'Exploit used',
    commandsExecuted: 'Commands executed',
    status: {
      active: 'Active',
      inactive: 'Inactive',
      closed: 'Closed',
      stale: 'Stale',
      idle: 'Idle',
      error: 'Error',
      unknown: 'Unknown',
      queued: 'Queued',
      running: 'Running',
      pending: 'Pending',
      completed: 'Completed',
      failed: 'Failed'
    },
    badges: {
      root: 'ROOT',
      persistent: 'PERSISTENT'
    },
    persistence: {
      installed: 'Installed',
      notInstalled: 'Not installed'
    },
    quickPrompts: {
      help: 'Help',
      privesc: 'Privesc',
      persistence: 'Persistence',
      lateral: 'Lateral movement',
      pocAuto: 'Auto PoC',
      aptModules: 'APT modules'
    },
    errors: {
      connectionError: 'Server connection error',
      loadingError: 'Error loading sessions',
      actionError: 'Error executing action',
      serverError: 'Internal server error',
      serviceUnavailable: 'Service temporarily unavailable',
      loadFailed: 'Loading failed',
      screenshotFailed: 'Screenshot failed',
      privescFailed: 'Privilege escalation failed',
      persistenceFailed: 'Persistence installation failed',
      aptExecutionFailed: 'APT module execution failed'
    },
    actions: {
      screenshotSuccess: 'Screenshot captured',
      privescSuccess: 'Privilege escalation successful',
      privescCompleted: 'Privilege escalation attempt completed',
      persistenceSuccess: 'Persistence mechanism installed',
      persistenceCompleted: 'Installation completed'
    }
  },

  // Support
  support: {
    title: 'Support',
    myTickets: 'My Support Tickets',
    manageRequests: 'Manage your assistance requests',
    newTicket: 'New ticket',
    ticketDetails: 'Ticket details',
    subject: 'Subject',
    message: 'Message',
    priority: 'Priority',
    status: 'Status',
    category: 'Category',
    created: 'Created',
    createdOn: 'Created on',
    updated: 'Last updated',
    resolved: 'Resolved',
    resolvedOn: 'Resolved on',
    noTickets: 'No tickets',
    noTicketsFound: 'No tickets found',
    noTicketsYet: 'You haven\'t created any support tickets yet',
    tryModifyingSearch: 'Try modifying your search criteria',
    createFirstTicket: 'Create my first ticket',
    sendMessage: 'Send message',
    send: 'Send',
    sending: 'Sending...',
    closeTicket: 'Close ticket',
    closing: 'Closing...',
    ticketClosed: 'This ticket is closed. For a new request, create a new ticket.',
    search: 'Search for a ticket...',
    allStatuses: 'All statuses',
    refresh: 'Refresh',
    backToTickets: 'Back to tickets',
    ticketNumber: 'Number',
    you: 'You',
    supportTeam: 'SYLink Support',
    system: 'System',
    writeReply: 'Write your reply...',
    detailedDescription: 'Detailed description',
    informations: 'Information',
    needHelp: 'Need help?',
    responseTime: 'Estimated response time',
    responseTimeDesc: 'Our team usually responds within 24 business hours. Urgent tickets are processed with priority. You will receive an email notification as soon as a response is provided.',
    supportResponseDesc: 'Our support team usually responds within 24 business hours. For emergencies, please indicate high priority.',
    newTicketTitle: 'New Ticket',
    newTicketDesc: 'Describe your problem and our team will respond quickly',
    describeIssue: 'Briefly describe your problem...',
    relatedWorkspace: 'Related Client / Workspace (optional)',
    noSpecificWorkspace: 'No specific workspace',
    detailedDescPlaceholder: 'Describe your problem in detail. The more information you provide, the faster we can help you...\n\n- What are you trying to do?\n- What is happening?\n- What did you expect?\n- Do you have an error message?',
    charactersCount: '{count} characters',
    charactersMin: '{count} characters (minimum {min})',
    cancel: 'Cancel',
    createTicket: 'Create ticket',
    creating: 'Creating...',
    rateSupport: 'How would you rate the quality of our support?',
    comment: 'Comment (optional)...',
    confirm: 'Confirm',
    messages: 'message',
    messagesPlural: 'messages',
    resolutionNotes: 'Resolution notes',
    yourRating: 'Your rating',

    // Statuses
    statuses: {
      open: 'Open',
      in_progress: 'In Progress',
      waiting_customer: 'Waiting for your response',
      waiting_internal: 'In processing',
      resolved: 'Resolved',
      closed: 'Closed'
    },

    // Priorities
    priorities: {
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      urgent: 'Urgent',
      lowDesc: 'Not urgent, can wait',
      mediumDesc: 'Normal importance',
      highDesc: 'Requires quick attention',
      urgentDesc: 'Critical impact on activity',
      priority: 'Priority'
    },

    // Categories
    categories: {
      technical: 'Technical',
      billing: 'Billing',
      feature_request: 'Feature Request',
      bug_report: 'Bug Report',
      account: 'Account',
      security: 'Security',
      other: 'Other',
      technicalDesc: 'Technical problems, errors, malfunctions',
      billingDesc: 'Questions about invoices, payments, subscriptions',
      feature_requestDesc: 'Improvement suggestions or new features',
      bug_reportDesc: 'Report a bug or unexpected behavior',
      accountDesc: 'Account management, access, permissions',
      securityDesc: 'Security questions or concerns',
      otherDesc: 'Other type of request'
    },

    // Errors
    errors: {
      loadingTickets: 'Error loading tickets',
      loadingTicket: 'Error loading ticket',
      sendingMessage: 'Error sending message',
      closingTicket: 'Error closing ticket',
      creatingTicket: 'Error creating ticket',
      ticketNotFound: 'Ticket not found',
      retry: 'Retry',
      fixFormErrors: 'Please correct the errors in the form',
      subjectRequired: 'Subject is required',
      subjectMinLength: 'Subject must contain at least 5 characters',
      descriptionRequired: 'Description is required',
      descriptionMinLength: 'Description must contain at least 20 characters'
    },

    // Success messages
    success: {
      ticketCreated: 'Ticket {number} created successfully',
      messageSent: 'Message sent',
      ticketClosed: 'Ticket closed successfully'
    }
  },

  // Attack
  attack: {
    title: 'Attack Center',
    description: 'Advanced attack tools and dynamic orchestrator',
    selectTarget: 'Select target',
    selectTechnique: 'Select technique',
    launchAttack: 'Launch attack',
    attackInProgress: 'Attack in progress',
    attackCompleted: 'Attack completed',
    attackFailed: 'Attack failed',
    techniques: 'Techniques',
    payloads: 'Payloads',
    results: 'Results',
    dynamicOrchestrator: 'Dynamic Orchestrator',
    attackGraph: 'Attack Graph',
    attackBuilder: 'Attack Builder',
    launchChain: 'Launch chain',
    continueChain: 'Resume',
    restartAll: 'Restart all',
    executing: 'Executing...',
    aiSuggestions: 'AI Suggestions',
    ready: 'Ready',
    inProgress: 'In progress...'
  },

  // Pricing
  pricing: {
    title: 'Choose your plan',
    subtitle: 'Security solutions adapted to all business sizes. Start for free and scale according to your needs.',
    monthly: 'Monthly',
    yearly: 'Yearly',
    yearlyDiscount: '-17%',
    perMonth: 'month',
    perYear: 'year',
    ht: 'excl. VAT',
    or: 'Or',
    perMonthShort: '/mo',
    onQuote: 'On quote',
    free: 'Free',
    // Plan names and descriptions
    plans: {
      gratuit: {
        name: 'Free',
        subtitle: 'Discovery',
        description: 'Ideal for testing the platform',
        cta: 'Start for free'
      },
      pro: {
        name: 'Pro',
        subtitle: 'Most popular',
        description: 'For professionals and SMBs',
        cta: 'Choose Pro',
        badge: 'Recommended'
      },
      entreprise: {
        name: 'Enterprise',
        subtitle: 'For large teams',
        description: 'Advanced features and dedicated support',
        cta: 'Choose Enterprise'
      },
      entreprise_plus: {
        name: 'Group',
        subtitle: 'For large organizations',
        description: 'Extended volume and premium support',
        cta: 'Choose Group'
      },
      sur_mesure: {
        name: 'Custom',
        subtitle: 'Customized solution',
        description: 'Adapted to your specific needs',
        cta: 'Contact us'
      }
    },
    // Features
    features: {
      simulationOnly: 'Simulation mode only',
      oneUser: '1 user',
      oneTarget: '1 test target',
      basicDashboard: 'Basic dashboard',
      realScans: 'Real scans',
      pdfReports: 'PDF reports',
      technicalSupport: 'Technical support',
      apiAccess: 'API Access',
      unlimitedScans: 'Unlimited AI scans',
      fiveUsers: '5 users',
      tenTargets: '10 targets',
      customPdfReports: 'Custom PDF reports',
      credentialSearch: 'Credential search',
      autoScheduling: 'Auto scheduling',
      prioritySupport: 'Priority support',
      allProFeatures: 'All Pro features +',
      fifteenUsers: '15 users',
      thirtyTargets: '30 targets',
      ssoSaml: 'SSO / SAML',
      complianceAudit: 'Compliance audit',
      slaGuarantee: '99.9% SLA guarantee',
      dedicatedSupport: 'Dedicated support',
      teamTraining: 'Team training included',
      allEnterpriseFeatures: 'All Enterprise features +',
      unlimitedUsers: 'Unlimited users',
      fiftyTargets: '50 targets',
      advancedWorkspaces: 'Advanced multi-workspaces',
      whiteLabelReports: 'White-label reports',
      support24_7: '24/7 dedicated support',
      accountManager: 'Dedicated account manager',
      customOnboarding: 'Custom onboarding',
      allGroupFeatures: 'All Group features +',
      dedicatedInfra: 'Dedicated infrastructure',
      customIntegrations: 'Custom integrations',
      specificDevelopment: 'Specific developments',
      sourceCodeAudit: 'Source code audit',
      manualPentest: 'Manual penetration tests',
      cissoSupport: 'CISO support',
      customContract: 'Custom contract'
    },
    // Sections
    whyChoose: 'Why choose SYLink Pentest?',
    aiTitle: 'Artificial Intelligence',
    aiDesc: 'Our AI analyzes and exploits vulnerabilities autonomously, simulating the behavior of an expert pentester.',
    securityTitle: 'Maximum Security',
    securityDesc: 'Your data is encrypted and secure. No sensitive information is stored after tests.',
    reportsTitle: 'Detailed Reports',
    reportsDesc: 'Generate professional PDF reports with remediation recommendations and CVSS scoring.',
    // FAQ
    faqTitle: 'Frequently asked questions',
    faqCanChangePlan: 'Can I change my plan?',
    faqCanChangePlanAnswer: 'Yes, you can upgrade or downgrade your plan at any time. Changes are effective immediately and prorated.',
    faqFreePlan: 'How does the free plan work?',
    faqFreePlanAnswer: 'The free plan allows you to test the platform in simulation mode. No real scans are performed but you discover all the features.',
    faqCommitment: 'Is there a commitment?',
    faqCommitmentAnswer: 'No commitment. You can cancel at any time. Annual billing offers 2 months free.',
    faqSupport: 'What support is included?',
    faqSupportAnswer: 'The Pro plan includes priority email support. The Enterprise plan benefits from 24/7 dedicated support.',
    // Contact CTA
    needHelpChoosing: 'Need help choosing?',
    needHelpDesc: 'Our team is available to advise you and answer all your questions. Get a personalized platform demonstration.',
    contactUs: 'Contact us',
    requestCall: 'Request a call',
    // Banners
    welcomeTitle: 'Welcome to SYLink Pentest!',
    welcomeDesc: 'Your account is activated. Choose the plan that suits your needs.',
    paymentError: 'Payment error',
    close: 'Close',
    redirecting: 'Redirecting...',
    securedByStripe: 'Secure payment by Stripe'
  },

  // Active Directory
  ad: {
    title: 'Active Directory',
    description: 'AD attack tools with AI LLM assistance and automated PoC',
    domain: 'Domain',
    dcIp: 'Domain Controller IP',
    username: 'Username',
    password: 'Password',
    ntlmHash: 'NTLM Hash (optional)',
    dcConfiguration: 'Domain Controller Configuration',
    attacks: 'AD Attacks',
    ldapPentest: 'LDAP/LDAPS Pentest',
    searchPlaceholder: 'Search for an attack, a tool...',
    allCategories: 'All categories',
    attackCategories: 'Attack Categories',
    targetResults: 'Target / Results',
    noDataMessage: 'Select an attack to start',
    noDataHint: 'Or use Auto PoC for an attack chain',
    readyToStart: 'Ready to start',
    stats: {
      attacks: 'Attacks',
      successful: 'Successful',
      failed: 'Failed',
      credentials: 'Credentials',
      users: 'Users',
      paths: 'Paths'
    },
    attackWizard: 'AD Attack Wizard'
  },

  // Notifications
  notifications: {
    managementCenter: 'Alerts and events management center',
    aiAssistant: 'AI Assistant',
    aiAssistantTitle: 'AI Assistant - Notifications',
    aiPlaceholder: 'Ask a question about your notifications...',
    settings: 'Notification settings',
    soundEnabled: 'Sound enabled',
    criticalOnly: 'Critical only',
    autoMarkRead: 'Auto mark read',
    filters: 'Filters',
    total: 'Total',
    unread: 'Unread',
    critical: 'Critical',
    warning: 'Warning',
    success: 'Success',
    info: 'Info',
    markAllRead: 'Mark all read',
    clearAll: 'Clear all',
    noNotifications: 'No notifications',
    noNotificationsDesc: 'You have no notifications at the moment',
    allRead: 'All your notifications are read',
    noNotificationsType: 'No notifications of type "{type}"',

    // Notification types
    typeCritical: 'Critical',
    typeWarning: 'Warning',
    typeSuccess: 'Success',
    typeInfo: 'Info',

    // Notification messages
    criticalVulnsFound: '{count} critical vulnerabilit{count, plural, =1 {y} other {ies}}',
    vulnsDetected: '{count} vulnerabilit{count, plural, =1 {y} other {ies}} detected',
    hostsScanned: '{count} hosts scanned on {target}',
    scanCompletedNoVulns: 'Scan completed - No vulnerabilities',
    noVulnsDetected: 'No vulnerabilities detected on {target}',
    scanInProgress: 'Scan in progress',
    analyzing: 'Analyzing {target}...',
    scanFailed: 'Scan failed',
    errorOn: 'Error on {target}',

    // Time
    justNow: 'Just now',
    minutesAgo: '{count}min ago',
    hoursAgo: '{count}h ago',
    daysAgo: '{count}d ago',
    scanRunning: 'Scan running',
    viewAll: 'View all notifications',
    scanCompleted: 'Scan completed'
  },

  // Branding (Login/Register pages)
  branding: {
    platformTitle: 'Autonomous',
    platformSubtitle: 'Pentest Platform',
    platformDescription: 'AI-powered security analysis with automated exploitation and detailed reports.'
  },

  // Features (Login/Register pages)
  features: {
    autonomousAI: {
      title: 'Autonomous AI',
      description: 'AI pentester simulating a security expert',
      highlight: 'LLM On-Premise'
    },
    advancedDetection: {
      title: 'Advanced Detection',
      description: 'Automatic detection of critical flaws',
      highlight: '200K+ CVE'
    },
    completeTests: {
      title: 'Complete Tests',
      description: 'Network, web, API and infra audit',
      highlight: '100+ tools'
    },
    instantReports: {
      title: 'Instant Reports',
      description: 'Automatic generation of professional reports',
      highlight: '6+ formats'
    }
  },

  // Stats (Login/Register pages)
  stats: {
    availability: 'Availability',
    vulnerabilities: 'Vulnerabilities detected',
    monitoring: 'Monitoring',
    scanTime: 'Average scan time'
  },

  // Footer
  footer: {
    title: 'Security Scanner Platform',
    subtitle: 'Autonomous Penetration Testing System',
    terms: 'Terms of Use',
    termsShort: 'Terms of Use',
    sales: 'Terms of Sale',
    salesShort: 'Terms of Sale',
    privacy: 'Privacy Policy',
    legalNotice: 'Legal Notice',
    contact: 'Contact',
    version: 'Version',
    licence: 'Licence #',
    poweredBy: 'Powered by SYLink AI'
  },

  // Enrichment - ABSpider Integration
  enrichment: {
    title: 'Enrichment & Threat Intelligence',
    subtitle: 'Advanced domain and IP analysis with VirusTotal, security headers, email and geolocation',
    description: 'Analyze targets with multiple security intelligence sources',

    // Flat keys used by EnrichmentDashboard
    target: 'Target',
    type: 'Type',
    modules: 'Modules',
    quickScans: 'Quick Scans',
    threatSummary: 'Threat Intelligence Summary',
    recentScans: 'Recent Scans',
    riskScore: 'Risk Score',
    date: 'Date',
    noScans: 'No scans yet',
    scan: 'Scan',
    quickResult: 'Quick Scan Result',
    scanDetails: 'Scan Details',
    statusLabel: 'Status',

    // Navigation & Actions
    newScan: 'New scan',
    quickScan: 'Quick scan',
    fullScan: 'Full scan',
    viewDetails: 'View details',
    exportReport: 'Export report',
    refresh: 'Refresh',

    // Scan Types
    scanTypes: {
      virustotal: 'VirusTotal',
      headers: 'Security Headers',
      security_headers: 'Security Headers',
      email_security: 'Email Security',
      geoip: 'IP Geolocation',
      reverse_ip: 'Reverse IP',
      full: 'Full Scan',
      // Pentest scan types
      ai_scan: 'AI Scan',
      network_discovery: 'Network Discovery',
      vulnerability_scan: 'Vulnerability Scan',
      full_autonomous: 'Full Autonomous',
      full_auto: 'Full Autonomous',
      full_automation: 'Full Autonomous',
      expert: 'Expert Scan',
      api_pentest: 'API Pentest',
      iot_scan: 'IoT Scan',
      ot_scan: 'OT/SCADA Scan',
      ad_pentest: 'AD Pentest',
      ad_scan: 'Active Directory Scan',
      ad_recon: 'AD Reconnaissance',
      ad_full: 'Full AD Scan',
      ldap_scan: 'LDAP Scan',
      kerberos_scan: 'Kerberos Scan',
      web_scan: 'Web Scan',
      web: 'Web Scan',
      quick: 'Quick',
      quick_scan: 'Quick Scan',
      discovery: 'Discovery',
      enumeration: 'Enumeration',
      vulnerability: 'Vulnerabilities',
      exploitation: 'Exploitation',
      passive: 'Passive',
      aggressive: 'Aggressive',
      credentials: 'Credentials',
      recon: 'Reconnaissance',
      exploit: 'Exploitation',
      bypass: 'Bypass',
      nmap: 'Nmap Scan',
      nikto: 'Nikto Scan',
      internal: 'Internal Scan',
      external: 'External Scan',
      network: 'Network Scan'
    },

    // Status
    status: {
      pending: 'Pending',
      running: 'Running',
      completed: 'Completed',
      failed: 'Failed',
      cancelled: 'Cancelled'
    },

    // Threat Levels
    threatLevels: {
      safe: 'Safe',
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      critical: 'Critical'
    },

    // Form
    form: {
      targetDomain: 'Target domain',
      targetDomainPlaceholder: 'e.g.: example.com',
      targetIp: 'IP address (optional)',
      targetIpPlaceholder: 'e.g.: 192.168.1.1',
      scanType: 'Scan type',
      workspace: 'Workspace (optional)',
      startScan: 'Start scan',
      credits: 'Credits required'
    },

    // Results - General
    results: {
      title: 'Results',
      noResults: 'No results available',
      loading: 'Loading results...',
      riskScore: 'Risk score',
      threatLevel: 'Threat level',
      scannedAt: 'Scanned at',
      duration: 'Duration'
    },

    // Security Headers
    headers: {
      title: 'Security Headers Analysis',
      score: 'Score',
      grade: 'Grade',
      present: 'Present',
      missing: 'Missing',
      recommendations: 'Recommendations',
      headerName: 'Header',
      value: 'Value',
      status: 'Status',
      issues: 'Issues',
      gradeDescriptions: {
        A: 'Excellent - Optimal security',
        B: 'Good - Some improvements possible',
        C: 'Average - Improvements recommended',
        D: 'Poor - Significant improvements needed',
        F: 'Insufficient - Critical security to improve'
      }
    },

    // Email Security
    email: {
      title: 'Email Security',
      mxRecords: 'MX Records',
      spf: 'SPF (Sender Policy Framework)',
      dkim: 'DKIM (DomainKeys Identified Mail)',
      dmarc: 'DMARC (Domain-based Message Authentication)',
      valid: 'Valid',
      invalid: 'Invalid',
      notFound: 'Not found',
      policy: 'Policy',
      mechanisms: 'Mechanisms',
      selectors: 'Selectors',
      vulnerabilities: 'Detected vulnerabilities',
      recommendations: 'Recommendations'
    },

    // GeoIP
    geoip: {
      title: 'IP Geolocation',
      location: 'Location',
      country: 'Country',
      region: 'Region',
      city: 'City',
      coordinates: 'Coordinates',
      timezone: 'Timezone',
      network: 'Network information',
      isp: 'ISP',
      organization: 'Organization',
      asn: 'ASN',
      flags: 'Security flags',
      isProxy: 'Proxy detected',
      isVpn: 'VPN detected',
      isTor: 'Tor detected',
      isDatacenter: 'Datacenter',
      isHosting: 'Hosting'
    },

    // Reverse IP
    reverseIp: {
      title: 'Reverse IP Lookup',
      totalDomains: 'Domains found',
      domains: 'Domain list',
      sharedHosting: 'Shared hosting',
      hostingProvider: 'Hosting provider',
      suspiciousDomains: 'Suspicious domains',
      riskScore: 'Risk score'
    },

    // VirusTotal
    virustotal: {
      title: 'VirusTotal Analysis',
      reputation: 'Reputation',
      malicious: 'Malicious',
      suspicious: 'Suspicious',
      harmless: 'Harmless',
      undetected: 'Undetected',
      categories: 'Categories',
      lastAnalysis: 'Last analysis',
      permalink: 'VirusTotal link'
    },

    // Dashboard Stats
    stats: {
      totalScans: 'Total scans',
      completedScans: 'Completed scans',
      pendingScans: 'Pending scans',
      failedScans: 'Failed scans',
      averageScore: 'Average score',
      criticalThreats: 'Critical threats',
      highThreats: 'High threats',
      creditsUsed: 'Credits used'
    },

    // Errors
    errors: {
      scanFailed: 'Scan failed',
      insufficientCredits: 'Insufficient credits',
      invalidDomain: 'Invalid domain',
      invalidIp: 'Invalid IP address',
      networkError: 'Network error',
      timeout: 'Timeout exceeded',
      unknownError: 'Unknown error'
    },

    // Tooltips
    tooltips: {
      virusTotalCredit: 'Uses VirusTotal API to analyze reputation',
      headersCredit: 'Analyzes HTTP security headers',
      emailCredit: 'Checks SPF, DKIM and DMARC',
      geoipCredit: 'Geolocates the IP address',
      reverseIpCredit: 'Finds domains hosted on the same IP',
      fullCredit: 'Performs all analyses'
    }
  },

  // Antivirus (ClamAV)
  antivirus: {
    title: 'Antivirus Scanner',
    subtitle: 'Scan files for malware using ClamAV',
    scannerTab: 'File Scanner',
    adminTab: 'Administration',
    adminTitle: 'Antivirus Management',
    adminSubtitle: 'ClamAV monitoring and quarantine management',
    scanFile: 'Scan File',
    scanNow: 'Scan Now',
    scanAll: 'Scan All Files',
    scanning: 'Scanning...',
    dropOrClick: 'Drop file or click to select',
    dropFiles: 'Drop files here or click to select',
    maxSize: 'Maximum size per file',
    selectedFiles: 'Selected Files',
    recentScans: 'Recent Scans',
    summary: 'Scan Summary',

    // Status
    clean: 'Clean',
    infected: 'Infected',
    pending: 'Pending',
    unavailable: 'ClamAV Unavailable',

    // Stats
    totalScans: 'Total Scans',
    cleanFiles: 'Clean Files',
    infectedFiles: 'Infected Files',
    dataScanned: 'Data Scanned',
    threatsBySeverity: 'Threats by Severity',
    performance: 'Performance',
    avgScanTime: 'Avg Scan Time',
    cacheEntries: 'Cache Entries',

    // Table headers
    filename: 'Filename',
    size: 'Size',
    status: 'Status',
    threat: 'Threat',
    severity: 'Severity',
    scannedAt: 'Scanned',

    // ClamAV
    daemonStatus: 'Daemon Status',
    version: 'Version',
    signatureVersion: 'Signature Version',
    signatureCount: 'Signatures',
    reloadSignatures: 'Reload Signatures',

    // Quarantine
    quarantine: 'Quarantine',
    noQuarantine: 'No files in quarantine',
    quarantinedAt: 'Quarantined',
    expiresAt: 'Expires',
    cleanupExpired: 'Cleanup Expired',
    confirmDelete: 'Are you sure you want to permanently delete this file?',

    // Errors
    fileTooLarge: 'File too large',
    typeNotAllowed: 'File type not allowed',
    total: 'Total'
  },

  // Contracts & Signature
  contracts: {
    title: 'Contracts',
    newContract: 'New Contract',
    contractNumber: 'Contract Reference',
    status: 'Status',
    draft: 'Draft',
    pendingSignature: 'Pending Signature',
    signed: 'Signed',
    active: 'Active',
    completed: 'Completed',
    expired: 'Expired',
    cancelled: 'Cancelled',

    // Signature
    signature: {
      title: 'Electronic Signature',
      certificate: 'Electronic Signature Certificate',
      signatory: 'Signatory',
      signatoryName: 'Signatory Name',
      signatoryEmail: 'Signatory Email',
      signatoryFirstName: 'First Name',
      signatoryLastName: 'Last Name',
      signatureDate: 'Signature Date & Time',
      signatureType: 'Signature Type',
      drawn: 'Drawn',
      typed: 'Typed',
      uploaded: 'Uploaded',
      legalMention: 'Legal Mention',
      acceptPentest: 'Acknowledged for Pentest Authorization',

      // Verification
      verification: 'Verification',
      smsVerification: 'SMS Verification',
      smsVerified: 'Verified',
      smsPending: 'Pending',
      ipAddress: 'IP Address',
      userAgent: 'Browser',
      geolocation: 'Geolocation',

      // Integrity
      integrity: 'Document Integrity',
      documentHash: 'Document Hash',
      signatureHash: 'Signature Hash',
      hashAlgorithm: 'Algorithm',
      sha512: 'SHA-512',

      // Timeline
      timeline: 'Timeline',
      createdAt: 'Created',
      sentAt: 'Sent',
      viewedAt: 'Viewed',
      signedAt: 'Signed',
      viewCount: 'View Count',

      // Audit trail
      auditTrail: 'Audit Trail',
      action: 'Action',
      timestamp: 'Timestamp',
      viewed: 'Viewed',
      smsRequested: 'SMS Code Requested',
      smsVerifiedAction: 'SMS Code Verified',
      signedAction: 'Signature Completed',
      downloaded: 'Downloaded',

      // Certificate
      certificateType: 'CERTIFICATE OF COMPLETION',
      platform: 'Platform',
      eidas: 'Electronic signature compliant with eIDAS regulation (EU) 910/2014',
      generatedAt: 'Certificate generated on',

      // Actions
      downloadProof: 'Download Signature Proof',
      viewCertificate: 'View Certificate',
      resendEmail: 'Resend by Email',

      // Messages
      contractSigned: 'Contract signed successfully!',
      copySentByEmail: 'A copy of this certificate will be sent by email.',
      enterSmsCode: 'Enter SMS Code',
      smsCodeSent: 'SMS code sent',
      invalidCode: 'Invalid code',
      codeExpired: 'Code expired',
      tooManyAttempts: 'Too many attempts'
    }
  },

  // VPN Configuration
  vpn: {
    title: 'VPN Configuration',
    configurations: 'VPN Configurations',
    noConfigurations: 'No VPN configurations',
    uploadConfig: 'Upload configuration',
    connected: 'Connected',
    disconnected: 'Disconnected',
    connecting: 'Connecting...',
    disconnecting: 'Disconnecting...',
    connect: 'Connect',
    disconnect: 'Disconnect',
    server: 'Server',
    saveCredentials: 'Save credentials for this VPN',
    status: 'VPN Status',
    protocol: 'Protocol',
    interface: 'Interface',
    publicIp: 'Public IP',
    vpnIp: 'VPN IP',
    country: 'Country',
    city: 'City',
    connectedSince: 'Connected since',

    // Routes
    routes: {
      title: 'Network Routes',
      description: 'Manage custom network routes for VPN',
      addRoute: 'Add route',
      destination: 'Destination CIDR',
      destinationPlaceholder: '192.168.56.0/24',
      gateway: 'Gateway',
      gatewayPlaceholder: '192.168.10.1',
      routeDescription: 'Description',
      routeDescriptionPlaceholder: 'Client internal network',
      noRoutes: 'No routes configured',
      deleteRoute: 'Delete route',
      applyRoutes: 'Apply routes',
      routeAdded: 'Route added successfully',
      routeDeleted: 'Route deleted',
      routesApplied: 'Routes applied',
      invalidCidr: 'Invalid CIDR format',
      invalidGateway: 'Invalid IP address',
      active: 'Active',
      inactive: 'Inactive'
    },

    // Network Topology
    topology: {
      title: 'Network Topology',
      server: 'Sylink Server',
      internet: 'Internet',
      vpnGateway: 'VPN Gateway',
      clientNetwork: 'Client Network',
      online: 'Online',
      offline: 'Offline',
      activeRoutes: 'Active routes',
      totalRoutes: 'Total routes',
      networkGateway: 'Network Gateway',
      subnetsCount: '{{count}} subnets'
    },

    // Messages
    messages: {
      configUploaded: 'VPN configuration uploaded',
      configDeleted: 'VPN configuration deleted',
      connectionSuccess: 'VPN connected successfully',
      connectionFailed: 'VPN connection failed',
      disconnectionSuccess: 'VPN disconnected',
      disconnectionFailed: 'VPN disconnection failed'
    }
  },

  // Phishing Simulation
  phishing: {
    title: 'Phishing Simulation',
    subtitle: 'Test employee security awareness with simulated phishing campaigns',
    campaignsTab: 'Campaigns',
    templatesTab: 'Templates',
    targetsTab: 'Target Groups',
    analyticsTab: 'Analytics',
    settingsTab: 'Settings',
    totalCampaigns: 'Total Campaigns',
    emailsSent: 'Emails Sent',
    clickRate: 'Click Rate',
    reportRate: 'Report Rate',
    recentCampaigns: 'Recent Campaigns',
    newCampaign: 'New Campaign',
    campaignName: 'Campaign Name',
    status: 'Status',
    sent: 'Sent',
    opened: 'Opened',
    clicked: 'Clicked',
    reported: 'Reported',
    actions: 'Actions',
    viewDetails: 'View Details',
    emailTemplates: 'Email Templates',
    createTemplate: 'Create Template',
    targetGroups: 'Target Groups',
    createGroup: 'Create Group',
    groupName: 'Group Name',
    members: 'Members',
    lastUsed: 'Last Used',
    edit: 'Edit',
    delete: 'Delete',
    analyticsOverview: 'Analytics Overview',
    clickRateTrend: 'Click Rate Trend',
    reportRateTrend: 'Report Rate Trend',
    chartPlaceholder: 'Chart will display here',
    departmentComparison: 'Department Comparison',
    settings: 'Phishing Settings',
    smtpConfig: 'SMTP Configuration',
    smtpServer: 'SMTP Server',
    smtpPort: 'SMTP Port',
    trackingSettings: 'Tracking Settings',
    trackOpens: 'Track email opens',
    trackClicks: 'Track link clicks',
    trackSubmissions: 'Track credential submissions',
    saveSettings: 'Save Settings',
    reference: 'Reference',
    statusCompleted: 'Completed',
    statusActive: 'Active',
    statusScheduled: 'Scheduled',
    statusCancelled: 'Cancelled',
    statusDraft: 'Draft',
    categoryCredentialHarvest: 'Credential Harvest',
    categoryLinkClick: 'Link Click',
    categoryAttachment: 'Attachment'
  },

  // Sankey Analysis
  sankey: {
    title: 'Security Flow - Flow Diagram',
    clickForAiAnalysis: 'Click on an element for AI analysis',
    exploitable: 'Exploitable',
    nonExploitable: 'Non Exploitable',
    columns: {
      workspaces: 'Workspaces',
      targets: 'Targets',
      assets: 'Assets',
      vulnerabilities: 'Vulnerabilities',
      exploitability: 'Exploitability',
      cve: 'CVE'
    },
    legend: {
      workspaces: 'Workspaces',
      targets: 'Targets',
      critical: 'Critical',
      nonExploitable: 'Non Exploit.'
    },
    severity: {
      critical: 'Critical',
      high: 'High',
      medium: 'Medium',
      low: 'Low'
    },
    analysis: {
      model: 'Model',
      changeModel: 'Analyze with another LLM',
      selectModel: 'Select an LLM model',
      regenerateWith: 'Regenerate analysis with another model',
      recommended: 'Recommended',
      regenerate: 'Regenerate analysis'
    },
    noScansAvailable: 'No scans available for visualization',
    scansLabel: 'scans',
    hostsLabel: 'hosts',
    portsLabel: 'ports',
    occurrences: 'occurrence(s)',
    tooltip: {
      element: 'Element',
      scansHostsVulns: '{scans} scans • {hosts} hosts • {vulns} vulnerabilities',
      ipHostsVulns: '{ip} • {hosts} hosts • {vulns} vulnerabilities',
      vulnsCount: '{count} vulnerabilities',
      clickForAi: 'Click for AI analysis'
    },
    stats: {
      workspaces: 'Workspaces',
      targets: 'Targets',
      assets: 'Assets',
      vulnerabilities: 'Vulnerabilities',
      exploitable: 'Exploitable'
    }
  },

  // LLM Monitor
  llmMonitor: {
    title: 'LLM Orchestrator',
    subtitle: 'Model management and supervision with GPU acceleration',
    gpuStatus: 'GPU Status',
    vram: 'VRAM',
    utilization: 'Utilization',
    load: 'Load',
    loaded: 'Loaded',
    noTarget: 'No target',
    entries: 'entries',
    vulnerabilities: 'vulnerabilities',
    credentials: 'credentials',
    poolStatus: 'GPU Pool Status',
    servers: 'servers',
    moreModels: 'more',
    orchestratorMetrics: 'Orchestrator Metrics',
    totalRequests: 'Total Requests',
    modelSwaps: 'Model Swaps',
    avgSwapTime: 'Avg. Swap Time',
    inferences: 'Inferences',
    connected: 'Connected',
    disconnected: 'Disconnected',
    refresh: 'Refresh',
    availableModels: 'Available Models',
    activeSessions: 'Active Sessions',
    noActiveSessions: 'No active sessions',
    noSessionsHint: 'LLM sessions use artificial intelligence to automatically analyze vulnerabilities, generate reports, and coordinate penetration testing.',
    noSessionsAction: 'Start a session',
    readyStatus: 'Ready to start',
    howToStart: 'Launch a scan to start an LLM session',
    waitingForScan: 'Waiting for scan',
    quickActions: 'Quick Actions',
    newSession: 'New Session',
    requestCheckpoint: 'Request Checkpoint',
    hashcatTasks: 'Hashcat Tasks',
    loadStatusFailed: 'Failed to load LLM status',
    loadingModel: 'Loading {{model}}...',
    swapFailed: 'Failed to swap model',
    noModel: 'None',
    online: 'Online',
    offline: 'Offline'
  },

  // OSINT translations (used by ScansList.jsx translateScanType)
  osint: {
    scanTypes: {
      virustotal: 'VirusTotal',
      headers: 'Security Headers',
      security_headers: 'Security Headers',
      email_security: 'Email Security',
      geoip: 'IP Geolocation',
      reverse_ip: 'Reverse IP',
      full: 'Full Scan',
      domain: 'Domain',
      ip: 'IP Address',
      url: 'URL',
      network_discovery: 'Network Discovery',
      vulnerability_scan: 'Vulnerability Scan',
      full_autonomous: 'Full Autonomous',
      full_auto: 'Full Autonomous',
      full_automation: 'Full Autonomous',
      expert: 'Expert Scan',
      api_pentest: 'API Pentest',
      iot_scan: 'IoT Scan',
      ot_scan: 'OT/SCADA Scan',
      ad_pentest: 'AD Pentest',
      ad_scan: 'Active Directory Scan',
      ad_recon: 'AD Reconnaissance',
      ad_full: 'Full AD Scan',
      ldap_scan: 'LDAP Scan',
      kerberos_scan: 'Kerberos Scan',
      web_scan: 'Web Scan',
      web: 'Web Scan',
      quick: 'Quick',
      quick_scan: 'Quick Scan',
      discovery: 'Discovery',
      enumeration: 'Enumeration',
      vulnerability: 'Vulnerability',
      exploitation: 'Exploitation',
      passive: 'Passive',
      aggressive: 'Aggressive',
      credentials: 'Credentials',
      recon: 'Reconnaissance',
      exploit: 'Exploitation',
      bypass: 'Bypass',
      nmap: 'Nmap Scan',
      nikto: 'Nikto Scan',
      internal: 'Internal Scan',
      external: 'External Scan',
      network: 'Network Scan',
      // OWASP/ZAP related scan types
      owasp: 'OWASP Scan',
      owasp_scan: 'OWASP Scan',
      owasp_top10: 'OWASP Top 10',
      owasp_top_10: 'OWASP Top 10',
      zap: 'ZAP Scan',
      zap_scan: 'ZAP Scan',
      owasp_zap: 'OWASP ZAP Scan',
      // Additional scan types
      sqlmap: 'SQLMap Scan',
      openvas: 'OpenVAS Scan',
      nuclei: 'Nuclei Scan',
      metasploit: 'Metasploit Scan',
      hydra: 'Hydra Test',
      wpscan: 'WordPress Scan',
      gobuster: 'Gobuster Scan',
      pentest: 'Pentest',
      stealth: 'Stealth Scan',
      full_scan: 'Full Scan',
      standard: 'Standard'
    }
  }
};
